const trackEvent = (eventName, params = {}) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", eventName, params);
        console.log("[Analytics]", eventName, params);
    } else {
        console.log("[Analytics-disabled]", eventName, params);
    }
};

const trackPageView = (path) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
            page_path: path,
        });
        console.log("[Analytics]", "page_view", { page_path: path });
    } else {
        console.log("[Analytics-disabled]", "page_view", { page_path: path });
    }
};

export { trackEvent, trackPageView };
export default { trackEvent, trackPageView };
